export const GET_STORE_PENDING_VOUCHERS_ERROR =
  'GET_STORE_PENDING_VOUCHERS_ERROR';
export const GET_STORE_PENDING_VOUCHERS_START =
  'GET_STORE_PENDING_VOUCHERS_START';
export const GET_STORE_PENDING_VOUCHERS_SUCCESS =
  'GET_STORE_PENDING_VOUCHERS_SUCCESS';
